function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useCallback, createContext } from "react";
import PropTypes from "prop-types";
import { makeStyles, styled } from "@material-ui/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Provider, createStoreHook, createDispatchHook, createSelectorHook } from "react-redux";
import WebIM, { initIMSDK } from "../utils/WebIM";
import store from "../redux/index";
import GlobalPropsActions from "../redux/globalProps";
import createlistener from "../utils/WebIMListen";
import MessageActions from "../redux/message";
import SessionActions from "../redux/session";
import ThreadActions from "../redux/thread";
import _ from "lodash";
import "../i18n";
import "../common/iconfont.css";
import SessionList from "../EaseChat/session/sessionList";
import EaseChat from "../EaseChat/chat/index";
import EaseLivestream from "../EaseLivestream/chat/index";
var uikit_store = React.createContext();
export var useDispatch = createDispatchHook(uikit_store);
export var useSelector = createSelectorHook(uikit_store);
export var EaseAppContext = createContext();
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%",
      height: "100%",
      display: "flex"
    },
    grid: {
      backgroundColor: "rgba(206, 211, 217, 0.3)",
      width: '360px'
    }
  };
});
var Item = styled(Grid)(function (_ref) {
  var theme = _ref.theme;
  return {};
});

var EaseApp = function EaseApp(props) {
  var dispatch = useDispatch(null);
  var classes = useStyles();
  var handleClickItem = useCallback(function (session) {
    props.onConversationClick && props.onConversationClick(session);
    var sessionType = session.sessionType,
        sessionId = session.sessionId,
        name = session.name;

    if (!session.lastMessage) {
      dispatch(MessageActions.fetchMessage(sessionId, sessionType));
    }

    WebIM.conn.getPresenceStatus({
      usernames: [sessionId]
    }).then(function (res) {
      var _presenceExt;

      var extFlag = false;
      var data = res.result[0];
      Object.values(data.status).forEach(function (val) {
        if (Number(val) === 1) {
          extFlag = true;
        }
      });

      if (!extFlag) {
        data.ext = 'Offline';
      }

      dispatch(GlobalPropsActions.setGlobalProps({
        to: sessionId,
        chatType: sessionType,
        name: name,
        presenceExt: (_presenceExt = {}, _presenceExt[sessionId] = {
          ext: data.ext
        }, _presenceExt)
      }));
    })["catch"](function (e) {
      console.log(e);
      dispatch(GlobalPropsActions.setGlobalProps({
        to: sessionId,
        chatType: sessionType,
        name: name
      }));
    });
    dispatch(SessionActions.setCurrentSession(sessionId));
    dispatch(MessageActions.clearUnreadAsync(sessionType, sessionId));
    dispatch(ThreadActions.updateThreadStates(false));
    dispatch(ThreadActions.getCurrentGroupRole({
      sessionType: sessionType,
      sessionId: sessionId
    }));
  }, [props.width]);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      position: "absolute",
      width: "100%",
      height: "calc(100%)"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.grid
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      width: '360px'
    }
  }, /*#__PURE__*/React.createElement("div", null, props.header), /*#__PURE__*/React.createElement(EaseAppContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(SessionList, {
    onClickItem: handleClickItem
  })))), /*#__PURE__*/React.createElement(Grid, {
    style: {
      width: '100%',
      minWidth: '788px'
    }
  }, /*#__PURE__*/React.createElement(EaseLivestream, props))));
};

var EaseAppProvider = function EaseAppProvider(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    context: uikit_store,
    store: store
  }, /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(EaseApp, props)));
};

export default EaseAppProvider;

EaseAppProvider.addConversationItem = function (session) {
  if (session && Object.keys(session).length > 0) {
    var _presenceExt2;

    var conversationType = session.conversationType,
        conversationId = session.conversationId,
        conversationName = session.conversationName,
        ext = session.ext;
    var dispatch = store.dispatch;
    var storeSessionList = store.getState().session;
    var sessionList = storeSessionList.sessionList;

    var isNewSession = _.findIndex(sessionList, function (v) {
      return v.sessionId === session.conversationId;
    });

    if (isNewSession === -1) {
      dispatch(SessionActions._pushSession({
        sessionType: session.conversationType,
        sessionId: session.conversationId,
        sessionName: session.conversationName
      }));
    }

    dispatch(SessionActions.setCurrentSession(conversationId));
    dispatch(SessionActions.topSession(conversationId, conversationType));
    dispatch(GlobalPropsActions.setGlobalProps({
      to: conversationId,
      chatType: conversationType,
      name: conversationName,
      presenceExt: (_presenceExt2 = {}, _presenceExt2[conversationId] = ext, _presenceExt2)
    }));
    dispatch(MessageActions.clearUnreadAsync(conversationType, conversationId));
    dispatch(ThreadActions.updateThreadStates(false));
    dispatch(ThreadActions.getCurrentGroupRole({
      sessionType: conversationType,
      sessionId: conversationId
    }));
  }
};

EaseAppProvider.changePresenceStatus = function (ext) {
  console.log(ext, 'changePresenceStatus');
  var dispatch = store.dispatch,
      getState = store.getState;
  dispatch(GlobalPropsActions.setGlobalProps(_extends({}, getState().global.globalProps, {
    presenceExt: ext
  })));
};

EaseAppProvider.getSdk = function (props) {
  if (!WebIM.conn) {
    initIMSDK(props.appkey);
    createlistener(props);
  }

  return WebIM;
};

EaseAppProvider.thread = {
  //是否支持thread功能 默认：否

  /**
   * 
   * @param {boolean} status: thread服务可用状态
   */
  setShowThread: function setShowThread(status) {
    store.dispatch(ThreadActions.setShowThread(status));
  },
  //是否有thread编辑面板，默认：否

  /**
   * 
   * @param {boolean} status 
   */
  setHasThreadEditPanel: function setHasThreadEditPanel(status) {
    store.dispatch(ThreadActions.setHasThreadEditPanel(status));
  },
  //关闭thread面板

  /**
   * @param {boolean} status 
   */
  closeThreadPanel: function closeThreadPanel() {
    store.dispatch(ThreadActions.updateThreadStates(false));
  }
};
EaseAppProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  username: PropTypes.string,
  agoraToken: PropTypes.string,
  password: PropTypes.string,
  appkey: PropTypes.string,
  header: PropTypes.node,
  addConversationItem: PropTypes.func,
  isShowUnread: PropTypes.bool,
  unreadType: PropTypes.bool,
  onConversationClick: PropTypes.func,
  showByselfAvatar: PropTypes.bool,
  easeInputMenu: PropTypes.string,
  menuList: PropTypes.array,
  handleMenuItem: PropTypes.func,
  onChatAvatarClick: PropTypes.func,
  isShowReaction: PropTypes.bool,
  customMessageList: PropTypes.array,
  customMessageClick: PropTypes.func,
  //thread-click edit panel,get thread info
  onEditThreadPanel: PropTypes.func,
  onOpenThreadPanel: PropTypes.func
} : {};
EaseAppProvider.defaultProps = {
  isShowUnread: true,
  unreadType: true
};